import { ProductType } from '@common/enums';
import { ProductQty, SelectedItemMap } from '@common/models';
import { Feature } from '@common/models/feature.model';
import { convertProductsToProductDetailsList } from '@common/utils';
import { productQtyFromSelectedItems } from '@common/utils/productQtyFromSelectedItems';

export const getFeatureValueByName = (productFeatures: Feature[], name: string): string | undefined =>
    productFeatures?.find((feature) => feature.name === name)?.value;

export const convertCutoutsToProductDetails = convertProductsToProductDetailsList(ProductType.CUTOUT);

export const getCutoutsProductQty = (cutouts: SelectedItemMap): ProductQty[] => productQtyFromSelectedItems(cutouts);
